import { render, staticRenderFns } from "./CaseDetailComponent.vue?vue&type=template&id=fbcbe748&scoped=true"
import script from "./CaseDetailComponent.vue?vue&type=script&lang=ts"
export * from "./CaseDetailComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcbe748",
  null
  
)

export default component.exports